import { ProjectRecord } from './project-types';
import { formatDateNL } from './project-utils';

export function buildCitation(p: ProjectRecord, accessedAt = new Date()): string {
  const accessed = formatDateNL(accessedAt.toISOString());
  return `${p.organizationName}. "${p.projectName}". ${p.sourceDomain}. Accessed ${accessed}. ${p.projectLink}`;
}
